// extracted by mini-css-extract-plugin
export default {"leftside":"MenuPage_leftside__TQCWL","rightside":"MenuPage_rightside__EwEDR","framesChoice":"MenuPage_framesChoice__y0rXh","buttonsArea":"MenuPage_buttonsArea__J0IZ4"};